import { render, staticRenderFns } from "./session-sso-callback.vue?vue&type=template&id=657bc97b&scoped=true&lang=pug&"
import script from "./session-sso-callback.vue?vue&type=script&lang=js&"
export * from "./session-sso-callback.vue?vue&type=script&lang=js&"
import style0 from "./session-sso-callback.vue?vue&type=style&index=0&id=657bc97b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657bc97b",
  null
  
)

export default component.exports